export const PENDING_FAVOURITE_ASSET_ID = "favAssetId";
export const PENDING_FAVOURITE_PREVIEW_OPEN = "isPreviewOpen";
